import React from 'react';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="section__header">
          <span className="section__tag">About Us</span>
          <h2 className="section__title">
            Technology with a
            <span className="gradient-text"> Purpose</span>
          </h2>
          <p className="section__subtitle">
            WolfTechnologies is a UK-based software company dedicated to building
            mobile applications that transform how people interact with technology.
          </p>
        </div>

        <div className="about__grid">
          <div className="about__card">
            <div className="about__card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h3>Consumer-First Design</h3>
            <p>
              Every app we build starts with the end user. We obsess over user experience,
              ensuring our applications are intuitive, delightful, and genuinely useful
              in people's daily lives.
            </p>
          </div>

          <div className="about__card">
            <div className="about__card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
              </svg>
            </div>
            <h3>AI-Native Approach</h3>
            <p>
              We integrate artificial intelligence at the core of our applications,
              not as an afterthought. From intelligent recommendations to natural
              language understanding, AI powers every interaction.
            </p>
          </div>

          <div className="about__card">
            <div className="about__card-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z" />
              </svg>
            </div>
            <h3>Cloud-Native Architecture</h3>
            <p>
              Built entirely on AWS, our infrastructure scales effortlessly.
              We leverage serverless computing, managed databases, and global
              CDN delivery to ensure blazing performance worldwide.
            </p>
          </div>
        </div>

        <div className="about__mission">
          <div className="about__mission-content">
            <span className="section__tag">Our Mission</span>
            <h3>Empowering Everyday Life Through Intelligent Mobile Technology</h3>
            <p>
              We believe the best technology disappears into the background, quietly
              making life better. Our mission is to create mobile applications that
              leverage the power of AI and cloud computing to solve real problems for
              real people across the UK and beyond.
            </p>
          </div>
          <div className="about__mission-stats">
            <div className="about__mission-stat">
              <span className="about__mission-number gradient-text">2</span>
              <span className="about__mission-label">Platforms<br/>iOS & Android</span>
            </div>
            <div className="about__mission-stat">
              <span className="about__mission-number gradient-text">UK</span>
              <span className="about__mission-label">Headquartered<br/>& Operated</span>
            </div>
            <div className="about__mission-stat">
              <span className="about__mission-number gradient-text">AI</span>
              <span className="about__mission-label">First<br/>Architecture</span>
            </div>
            <div className="about__mission-stat">
              <span className="about__mission-number gradient-text">AWS</span>
              <span className="about__mission-label">Cloud<br/>Infrastructure</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
